const $slider = $('.js-slider');


if ($slider.length) {
    $slider.each(function(i) {
        const $g = $(this);
        const $container = $g.closest('.js-slider-wrap');

        // Возможность делать множественные галереи
        $g.addClass(`js-slider-${i}`);
        $container.find('.js-slider-pagination').addClass(`js-slider-pagination-${i}`);

        $container.append(`<div class="slider-pagination js-slider-pagination-${i}"></div>`);

        $container.find('.js-slider-inner').append(`
            <div class="slider-buttons-wrap">
                <div class="slider-prev js-slider-prev"></div>
                <div class="slider-next js-slider-next"></div>            
            </div>
            
        `);

        // Инициализация
        const swiper = new Swiper(`.js-slider-${i}`, {
            loop: true,
            centeredSlides: true,
            lazy: {
                loadPrevNext: true
            },
            threshold: 10,
            roundLengths: true,
            speed: 300,
            a11y: true,
            pagination: {
                el: `.js-slider-pagination-${i}`,
            },
        });

        $container.find('.js-slider-next').on('click', () => {
            swiper.slideNext();
        });

        $container.find('.js-slider-prev').on('click', () => {
            swiper.slidePrev();
        });
    });

}



// WEBPACK FOOTER //
// ./_src/js/modules/Slider.js